import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { IoQrCodeOutline } from 'react-icons/io5';

import { Box, UnstyledButton } from '@mantine/core';

import { EventHelpers } from 'helpers/EventHelpers';
import { ShowtimeHelpers } from 'helpers/ShowtimeHelpers';

import menuCx from 'components/header/components/Menu.module.scss';
import { useSavedProfiles } from 'components/showtime/hooks/useSavedProfiles';
import { useEvents } from 'hooks/use-events';

import cx from './ReplusShowtimeLink.module.scss';

const ReplusShowtimeLink = () => {
    const pathname = usePathname();
    const { events } = useEvents();
    const { qrScans } = useSavedProfiles();

    // Visitors with scans keep the way back to them long after the show
    if (!qrScans.length && !events.some(EventHelpers.isCurrentUpcomingOrRecent)) {
        return null;
    }

    const href = ShowtimeHelpers.urls.showtime();

    return (
        <UnstyledButton
            component={Link}
            href={href}
            className={menuCx.linkWrapper}
            data-active={pathname === href}
            aria-label="RE+ Showtime"
            style={{ flexShrink: 0 }}
        >
            <Box className={`${menuCx.link} ${cx.label}`} c="#5146ff" style={{ gap: 6, whiteSpace: 'nowrap' }}>
                <IoQrCodeOutline size={16} style={{ margin: 0 }} />
                <span className={cx.text}>
                    <span className={cx.brand}>RE+ </span>
                    Showtime
                </span>
            </Box>
        </UnstyledButton>
    );
};

export { ReplusShowtimeLink };
